const experienceData = [
  {
    date: "Aug 2022 - Present",
    description: `- Worked on mobile and web applications built as a usage for company’s stores and products maintenance using the technologies Angular, Ionic, Cordova, and Android Studio. Also worked on a web application built for company’s analytical monitorization using the technologies React, and Django as backend.
      - Worked as a full-stack web developer on company’s products’ data analytics web application development using the technologies React, Redis, and Django.
      - Communicated updates on the ongoing project with the team and manager, ensuring alignment with the existing software using agile and scrum methodologies.
      - Provided ongoing maintenance, support, and enhancements in existing systems and platforms.
      - Explored and self-learned new technologies like Tailwind CSS, Three.js, and React Three Fiber during available free time and built projects to deep dive into and to understand the concepts and working of these technologies.`,
    role: `FULL STACK DEVELOPER
        MEDPLUS · OPTIVAL HEALTH SOLUTIONS`,
  },
  {
    date: "Feb 2022 - Aug 2022",
    description: `- Hands on experience and Application Development based on Django, Angular, JavaScript and TypeScript, MySQL, SQLite3, HTML, CSS and BootStrap.
        - Testing the written software with PyTest.`,
    role: `FULL STACK DEVELOPER [ INTERN ]
        MEDPLUS · OPTIVAL HEALTH SOLUTIONS`,
  },
  {
    date: "Dec 2021 - Feb 2022",
    description: `- Handled large sized data using Informatica PowerCenter Platform.
        - Used Bash and Unix based Shell Scripting Commands to maintain the system
        - Performed CRUD operations on the self-made databases using MySQL.`,
    role: `PROGRAMMER ANALYST [ INTERN ]
        COGNIZANT TECHNOLOGY SOLUTIONS`,
  },
];

export default experienceData;
